import Link from "next/link"
import clsx from "clsx"

import routes from "routes"
import URLUtils from "src/utils/URLUtils"

// view
import MyPageHeader from "src/components/common/MyPageHeader"
import TieupImg from "src/components/common/TieupImg"
import { useRouter } from "next/router"
import { useMemo } from "react"
import { usePermission } from "src/components/hooks/usePermission"
import { CreatorMypageBreadCrumbs } from "../../pages/creator/mypage/BreadCrumbs"
import { CREATOR_MYPAGE_ITEM } from "../../pages/creator/mypage/BreadCrumbs/constants"
import styles from "./CreatorMyPageCategoryTopLayout.module.scss"

type Props = {
  navActive?: "home" | "novels" | "illustrations" | "requests"
}

const CreatorMyPageCategoryTopLayout: React.FC<Props> = ({
  children,
  navActive,
}) => {
  usePermission([2])
  const router = useRouter()

  const isCreatorMypage = useMemo(() => {
    if (router.pathname === "/creator/mypage") {
      return true
    } else {
      return false
    }
  }, [router.pathname])

  const pageName = (() => {
    if (navActive === "novels") {
      return "小説一覧"
    }
    if (navActive === "illustrations") {
      return "イラスト一覧"
    }

    if (navActive === "requests") {
      return "たいあっぷ申請一覧"
    }

    return ""
  })()

  return (
    <>
      {navActive === "home" ? (
        <MyPageHeader
          title="マイページ"
          path={isCreatorMypage ? routes.creator() : routes.creatorMyPage()}
        />
      ) : (
        <CreatorMypageBreadCrumbs
          items={[CREATOR_MYPAGE_ITEM, { label: pageName }]}
        />
      )}
      <nav className={styles.HeaderNavi}>
        <div className={styles.HeaderNavi_inner}>
          <ul className={styles.HeaderNavi_list}>
            <li>
              <Link href={routes.creatorMyPage()}>
                <a
                  className={clsx(
                    styles.HeaderNavi_anchor,
                    navActive === "home" && styles["is-active"],
                  )}
                >
                  ホーム
                </a>
              </Link>
            </li>
            <li>
              <Link href={routes.creatorMyPageNovels()}>
                <a
                  className={clsx(
                    styles.HeaderNavi_anchor,
                    navActive === "novels" && styles["is-active"],
                  )}
                >
                  小説一覧
                </a>
              </Link>
            </li>
            <li>
              <Link href={routes.creatorMyPageIllustrations()}>
                <a
                  className={clsx(
                    styles.HeaderNavi_anchor,
                    navActive === "illustrations" && styles["is-active"],
                  )}
                >
                  イラスト一覧
                </a>
              </Link>
            </li>
            <li>
              <Link href={routes.creatorMyPageTieUpRequests()}>
                <a
                  className={clsx(
                    styles.HeaderNavi_anchor,
                    navActive === "requests" && styles["is-active"],
                  )}
                >
                  たいあっぷ申請一覧
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <div className={styles.Content}>
        <main className={styles.Content_main}>{children}</main>
        <aside className={styles.Content_sub}>
          <nav className={styles.SideNavi}>
            <ul className={styles.SideNavi_list}>
              <li>
                <Link href={routes.creatorMyPage()}>
                  <a
                    className={clsx(
                      styles.SideNavi_anchor,
                      navActive === "home" && styles["is-active"],
                    )}
                  >
                    ホーム
                  </a>
                </Link>
              </li>
              <li>
                <Link href={routes.creatorMyPageNovels()}>
                  <a
                    className={clsx(
                      styles.SideNavi_anchor,
                      navActive === "novels" && styles["is-active"],
                    )}
                  >
                    小説一覧
                  </a>
                </Link>
              </li>
              <li>
                <Link href={routes.creatorMyPageIllustrations()}>
                  <a
                    className={clsx(
                      styles.SideNavi_anchor,
                      navActive === "illustrations" && styles["is-active"],
                    )}
                  >
                    イラスト一覧
                  </a>
                </Link>
              </li>
              <li>
                <Link href={routes.creatorMyPageTieUpRequests()}>
                  <a
                    className={clsx(
                      styles.SideNavi_anchor,
                      navActive === "requests" && styles["is-active"],
                    )}
                  >
                    たいあっぷ申請一覧
                  </a>
                </Link>
              </li>
            </ul>
          </nav>
          {navActive === "home" && (
            <>
              <div className={styles.SideNaviUtil}>
                <div className={styles.SideNaviUtilItem}>
                  <Link href={routes.creatorMyPageNovelsCreateNovel()}>
                    <a className={styles.SideNaviUtilItemButton}>
                      新規小説登録
                    </a>
                  </Link>
                </div>
                <div className={styles.SideNaviUtilItem}>
                  <Link href={routes.creatorMyPageIllustrationNew()}>
                    <a className={styles.SideNaviUtilItemButton}>
                      新規イラスト登録
                    </a>
                  </Link>
                </div>
              </div>
              <div className="p-creatorMypage-sideBnr u-spacer-sm">
                <a
                  href={URLUtils.getHelpPage("guide/index.html#register")}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <TieupImg
                    src="/img/bnr_guide_register.png"
                    alt="小説・イラストの登録方法とコツ"
                  />
                </a>
              </div>
            </>
          )}
        </aside>
      </div>
    </>
  )
}

export default CreatorMyPageCategoryTopLayout
